module.exports = __webpack_public_path__ + "img/560a.b647fb25.png";